'use strict';

// Intl for IE11 and older
(typeof Intl !== 'function') && require('intl');

// override react-i18n default loader (forklifter), which doesn't support caching
var ReactI18n = require('react-i18n');
var loader = require('./TemplateLoader');
var React = require('react');
var utils = require('./index');
const { get } = require('lodash');

const i18nWithCardConfigMixin = {
    propTypes: {
        remoteConfig: React.PropTypes.object.isRequired
    },
    i18nWithCardConfig: function (contentKey, data) {
        let debitCardMetadataKey = 'consumerDebitCardMetadata';
        let cardName = get(this.props, `remoteConfig.${debitCardMetadataKey}.shortProductName`, '');
        let cardLegalName = get(this.props, `remoteConfig.${debitCardMetadataKey}.legalProductName`, '');
        return this.i18n(contentKey, {
            cardName,
            cardLegalName,
            ...data
        });
    },
    i18nWithProductList: function (contentKey, data = {}) {
        const productObj = get(this.props, 'cardInfo.pin_details.access_instruments', []);

        if (productObj.length > 0) {
            const andLabel = this.i18n('and.label');
            const listOfProduct = utils.formatProductNames(productObj, andLabel);

            if (!listOfProduct) {
                return '';
            }

            data.listOfProduct = listOfProduct;
        }

        return this.i18n(contentKey, {
            ...data
        });
    }
};

module.exports = (...paths) => {
    const i18nMixinCreator = ReactI18n.createi18n(loader, ReactI18n.user.getLocale());
    const i18nMixin = i18nMixinCreator(...paths);
    return {
        ...i18nMixin,
        ...i18nWithCardConfigMixin
    };
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/i18n.js
 **/